import { Helmet } from "react-helmet";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Container,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import Search from "@mui/icons-material/Search";
import InboxLayout from "../inbox/InboxLayout";
import { ReactComponent as Arrow } from "../../assets/images/chevron-right.svg";
import cssVariables from "../../theme/cssVariables";

const useStyles = makeStyles({
  media: {
    height: 200,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  blueBg: {
    background: "#6694CC",
  },
  purpleBg: {
    background: "#7580BD",
  },
  customCardSize: {
    height: 380,
  },
  cardContentSize: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    alignItems: "center",
    height: "calc(100% - 130px)",
  },
	toggleBtnRoot: {
    background: `#fff!important`,
    color: "#C2C2C2!important",
		width: "120px",
    borderColor: "#E5E5E5!important"
  },
  toggleBtnSelected: {
    background: `${cssVariables.color.primary}!important`,
    color: "#fff!important",
  },
	searchBar: {
		height: "48px!important",
	},
	".searchBar": {
		height: "48px!important",
	},
  textMore: {
    color: "#5DA196",
    textDecoration: "underline",
    display: "flex",
    cursor: "pointer"
  },
  iconArrow: {
    paddingLeft: "5px"
  }
});
const Inbox = (props) => {
  const { fullFunction } = props;
  const { t } = useTranslation();
  const [inboxType, setInboxType] = React.useState("received");
  const handleButtonGroup = (_, value) => {
    if(value) setInboxType(value);
  };
  const classes = useStyles();
  const navigate = useNavigate();
  const clickLink = (data) => {
    navigate(data, { replace: false });
  }
  const location = useLocation()
  let pathName = location?.pathname?.split("/") ?? []
  pathName = pathName.length > 1 ? pathName[1] : "app"
  return (
    <>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
        }}
      >
        {/* <Container maxWidth="xl"> */}
          <Grid container mb={2}>
            <Grid item display="flex" alignItems="center" justifyContent="space-between" sx={{width: "100%"}}>
              <Typography color="#404349" fontWeight="600" fontSize="24px">
                {t("home.label.inbox")}
              </Typography>
              {fullFunction &&
                <Typography fontSize={14} lineHeight="15.4px" classes={{ root: classes.textMore }} onClick={() => clickLink('/kpi/inbox')} >
                  {t('label.viewAll')} <Arrow classes={{ root: classes.iconArrow }}/>
                </Typography>
              }
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1} mb={2}>
            <Grid item xs="auto">
              <Box>
                <ToggleButtonGroup
                  value={inboxType}
                  onChange={handleButtonGroup}
                  aria-label="inbox type"
                  exclusive={true}
                >
                  <ToggleButton
                    value="received"
                    aria-label="centered"
                    classes={{ root: classes.toggleBtnRoot, selected: classes.toggleBtnSelected }}
                  >
                    <Typography style={{textTransform: 'none'}}>{t('home.label.received')}</Typography>
                  </ToggleButton>
                  <ToggleButton
                    value="sent"
                    aria-label="centered"
                    classes={{ root: classes.toggleBtnRoot, selected: classes.toggleBtnSelected }}
                  >
                    <Typography style={{textTransform: 'none'}}>{t('home.label.sent')}</Typography>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>
          </Grid>
          <InboxLayout selectedInbox={inboxType} path={pathName}/>
        {/* </Container> */}
      </Box>
    </>
  );
};
export default Inbox;
